import React, { useCallback, useMemo, useState } from "react";
import { useFormikContext } from "formik";

import { ListValueProp } from "@hitachivantara/uikit-react-core";

import MembersTable from "../MembersTable";

import MembersTableControls from "../MembersTableControls";

export interface MembersContent {
  initialPageSize?: number;
}

const MembersContent: React.FC<MembersContent> = ({ initialPageSize = 10 }) => {
  const [searchKey, setSearchKey] = useState("");
  const [viewOption, setViewOption] = useState<"all" | "member" | "default">(
    "all"
  );
  const [groupFilter, setGroupFilter] = useState<ListValueProp[]>([]);
  const { values, setFieldTouched, setFieldValue, setStatus } =
    useFormikContext<MembersFormData>();

  const setValueOnForm = useCallback(
    (
      property: string,
      selection: UserWithGroup | UserWithGroup[] | undefined
    ) => {
      setFieldTouched(property);
      setFieldValue(property, selection);
      // clearServerSideErrors
      setStatus({});
    },
    [setFieldTouched, setFieldValue, setStatus]
  );

  const onGroupFilterChange = (value: ListValueProp[]) => {
    setGroupFilter(value);
  };

  const onViewChange = (value: ListValueProp) => {
    if (value === undefined) {
      if (viewOption === "all") setViewOption("default");
      if (viewOption === "default" || viewOption === "member")
        setViewOption("all");
      return;
    }
    const result = value?.id === "member" ? "member" : "all";
    setViewOption(result);
  };

  const onSearchKeyChange = (value: string) => {
    setSearchKey(value);
  };

  const MemoTable = useMemo(
    () => (
      <MembersTable
        members={values.members || []}
        assignee={values.assignedUser}
        groupFilter={groupFilter}
        searchKey={searchKey}
        viewOption={viewOption}
        initialPageSize={initialPageSize}
        onAssigneeChange={(value) => {
          setValueOnForm("assignedUser", value);
        }}
        onMembersChange={(value) => {
          setValueOnForm("members", value);
        }}
      />
    ),
    [
      groupFilter,
      searchKey,
      setValueOnForm,
      values.assignedUser,
      values.members,
      viewOption,
      initialPageSize,
    ]
  );

  return (
    <>
      <MembersTableControls
        viewOption={viewOption}
        selectedFilters={groupFilter}
        onSearchKeyChange={onSearchKeyChange}
        onViewChange={onViewChange}
        onGroupFilterChange={onGroupFilterChange}
      />
      {MemoTable}
    </>
  );
};

export default MembersContent;
